<template>
	<el-dialog title="详情" v-model="isDetail" width="80%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="page_warp scroll-view">
			<div class="nav_warp">
				<div class="nav_item" :class="index == 0 ? 'nav_item_ac' : ''" @click="navClick(0)">
					<span>路线详情</span>
					<div v-if="index == 0" class="nav_item_line"></div>
				</div>
				<div class="nav_item" :class="index == 1 ? 'nav_item_ac' : ''" @click="navClick(1)">
					<span>关联运单</span>
					<div v-if="index == 1" class="nav_item_line"></div>
				</div>
			</div>

			<div class="custUpWarp" v-show="index == 0">
				<div class="dialog-container" style="max-height: 600px; overflow: auto">
					<p class="platTitle">路线历史明细</p>
					<div class="info-input-container">
						<div class="flex flex-y-center flex-wrap">
							<div class="w30 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span class="input-fail">*</span>
									<span>装货地：</span>
								</div>
								<span class="platItemRigth">{{loadWhNames}}</span>
							</div>
							<div class="w30 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span>卸货地：</span>
								</div>
								<span class="platItemRigth">{{unlWhNames}}</span>
							</div>
							<div class="w30 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span>装货平均耗时：</span>
								</div>
								<span class="platItemRigth">{{timeDeltaCount(avgLoadDuration)}}</span>
							</div>
							<div class="w30 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span>卸货平均耗时：</span>
								</div>
								<span class="platItemRigth">{{timeDeltaCount(avgUnlDuration)}}</span>
							</div>
							<div class="w30 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span>在途平均耗时：</span>
								</div>
								<span class="platItemRigth">{{timeDeltaCount(avgTravelDuration)}}</span>
							</div>
							<div class="w30 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span>平均总耗时：</span>
								</div>
								<span class="platItemRigth">{{timeDeltaCount(avgSumDuration)}}</span>
							</div>
							<div class="w30 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span>平均高速费：</span>
								</div>
								<span class="platItemRigth">{{avgFreewayCost}}</span>
							</div>
							<div class="w30 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span>平均燃料费：</span>
								</div>
								<span class="platItemRigth">{{avgFuelCost}}</span>
							</div>
							<div class="w30 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span>平均总成本：</span>
								</div>
								<span class="platItemRigth">{{avgSumCost}}</span>
							</div>
							<div class="w30 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span>平均运费收入：</span>
								</div>
								<span class="platItemRigth">{{avgFreightMoney}}</span>
							</div>
							<div class="w30 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span>平均运输利润：</span>
								</div>
								<span class="platItemRigth">{{avgSumIncome}}</span>
							</div>
							<div class="w30 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span>历史运行次数：</span>
								</div>
								<span class="platItemRigth">{{odrCount}}</span>
							</div>
						</div>
					</div>
					<div class="flex">
						<div class="rpt_tit">
							<p class="platTitle">路线标准设置
								<span class="auditwait" v-if="lineDefSet==null">未设置</span>
							</p>
						</div>
						<div class="editimg fontSize18" style="text-decoration: underline;">
							<div v-if="olseDefedit" class="flex">
								<div class="mr-10" @click="olseDefeditsave">保存</div>
								<div class="mr-10" @click="olseDefeditChange(false)">取消</div>
							</div>
							<div class="mr-10" @click="olseDefeditChange(true)" v-if="!olseDefedit">编辑</div>
						</div>
					</div>
					<div class="info-input-container">
						<div class="flex flex-y-center flex-wrap">
							<div class="w30 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span class="input-fail">*</span>
									<span>标准耗时：</span>
								</div>
								<el-input v-model="olseDefDuration" class="platItemRigth" placeholder="请输入"
									type="number" :readonly="olseDefeditisReadOnly" />
							</div>
							<div class="w30 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span class="input-fail">*</span>
									<span>标准里程：</span>
								</div>
								<el-input v-model="olseDefMilage" class="platItemRigth" placeholder="请输入"
									type="number" :readonly="olseDefeditisReadOnly" />
							</div>
							<div class="w30 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span>标准气耗：</span>
								</div>
								<el-input v-model="olseDefGas" class="platItemRigth" placeholder="请输入" type="number"
									:readonly="olseDefeditisReadOnly" />
							</div>
							<div class="w30 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span>标准油耗：</span>
								</div>
								<el-input v-model="olseDefFuel" class="platItemRigth" placeholder="请输入" type="number"
									:readonly="olseDefeditisReadOnly" />
							</div>
							<div class="w30 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span>标准路桥费：</span>
								</div>
								<el-input v-model="olseDefTollCost" class="platItemRigth" placeholder="请输入"
									type="number" :readonly="olseDefeditisReadOnly" />
							</div>
							<div class="w30 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span>标准高速费：</span>
								</div>
								<el-input v-model="olseDefFreewayCost" class="platItemRigth" placeholder="请输入"
									type="number" :readonly="olseDefeditisReadOnly" />
							</div>
						</div>
					</div>



				</div>
			</div>
			<div v-show="index==1" style="width: 100%;">
				<!-- <div class="top_content">
					<div class="top_input">
						<el-input placeholder="请输入"></el-input>
					</div>
					<div class="search_btn" @click="getData">查询</div>
				</div> -->
				<div class="bottom_content">
					<div class="table_container" v-bind:id="tableId">
						<el-table v-bind:data="tableData" stripe border style="width: 100%"
							v-bind:max-height="tableHeight" v-bind:header-cell-style="{
            textAlign: 'center',
            color: '#333333',
            background: '#F5F5F5',
          }" v-bind:cell-style="{ textAlign: 'center' }" empty-text="暂无数据">
							<!-- <el-table-column prop="roleId" label="角色ID"></el-table-column> -->
							<el-table-column fixed prop="odrId" label="运单号" width="120"></el-table-column>
							<el-table-column fixed prop="odrLoadpTime" label="运单日期" width="120"></el-table-column>
							<el-table-column fixed prop="vehHeadNo" label="车牌号" width="120"></el-table-column>
							<el-table-column prop="orgName" label="所属公司" width="100"></el-table-column>
							<!-- <el-table-column prop="heaMilage" label="标准里程" width="100"></el-table-column> -->
							<el-table-column prop="heaMilage" label="重车里程" width="100"></el-table-column>
							<el-table-column prop="loadDuration" label="装货耗时" width="100">
								<template #default="scope">
									<span>{{timeDeltaCount(scope.row.loadDuration)}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="unlDuration" label="卸货耗时" width="100">
								<template #default="scope">
									<span>{{timeDeltaCount(scope.row.unlDuration)}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="heaDuration" label="重车在途耗时" width="120">
								<template #default="scope">
									<span>{{timeDeltaCount(scope.row.heaDuration)}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="sumDuration" label="运输总耗时" width="100">
								<template #default="scope">
									<span>{{timeDeltaCount(scope.row.sumDuration)}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="freewayCost" label="高速费" width="100"></el-table-column>
							<el-table-column prop="tollCost" label="路桥费" width="100"></el-table-column>
							<el-table-column prop="fuelCost" label="燃料费" width="100"></el-table-column>
							<el-table-column prop="sumCost" label="运输成本" width="100"></el-table-column>
							<el-table-column prop="freightMilage" label="运费里程" width="100"></el-table-column>
							<el-table-column prop="freightPrice" label="运费单价" width="100"></el-table-column>
							<el-table-column prop="freightWeight" label="运费吨位" width="100"></el-table-column>
							<el-table-column prop="freightMoney" label="运输收入" width="100"></el-table-column>
							<el-table-column prop="occupyIncome" label="压车费收入" width="100"></el-table-column>
							<el-table-column prop="unloadIncome" label="分卸费收入" width="100"></el-table-column>
							<el-table-column prop="sumIncome" label="总收入" width="100"></el-table-column>
							<el-table-column prop="sumMoney" label="运输利润" width="100"></el-table-column>
							<!-- <el-table-column label="操作">
								<template #default="scope">
									<span class="default_color pointer m-right10"
										v-on:click="edit(scope.row.roleId)">编辑</span>
									<span class="default_color pointer m-right10"
										v-on:click="detail(scope.row.roleId)">详情</span>
									<span class="col-FF1A1A pointer" v-on:click="del(scope.row.roleId)">删除</span>
								</template>
							</el-table-column> -->
						</el-table>
					</div>
					<div class="flex flex-y-center flex-x-center m-top20">
						<el-config-provider :locale="locale">
							<el-pagination background v-model:currentPage="page" v-model:page-size="pageSize"
								:page-sizes="[5, 10, 15, 20]" layout="sizes, prev, pager, next, total, jumper"
								:total="totalCount" @size-change="getData" @current-change="getData" />
						</el-config-provider>
					</div>
				</div>
			</div>

		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		computed,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		imgFileToBase64,
		isPhone,
		isIdNo
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	export default defineComponent({
		name: "Detail",
		// emits: ["getData"],

		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			// const getData = () => {
			// 	context.emit("getData");
			// };
			onMounted(() => {
				let perms = proxy.$storage.get("perms");
				perms.forEach((el) => {
					if (el == "lineManage:list") {
						data.permissionItem.list = true;
					}
					if (el == "lineManage:del") {
						data.permissionItem.del = true;
					}
					if (el == "lineManage:set") {
						data.permissionItem.set = true;
					}
					if (el == "lineManage:export") {
						data.permissionItem.export = true;
					}
				});
				
				nextTick(() => {
					data.tableHeight =
						document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
				});
			});

			const data = reactive({
				tableId: "roleManagementTable",
				isDetail: false,
				index: 0,
				page: 1,
				pageSize: 10,
				totalCount: 0,
				tableData: [],
				tableHeight: 0,
				olseDefedit: false,
				olseDefeditisReadOnly: true,

				lineId: "20250609161228356",
				orgId: "TOP",
				odrType: "0",
				lineType: "0",
				odrCount: "1",
				whids: "14,16",
				whNames: "装货站点1,卸货站点1",
				loadWhids: "14",
				loadWhNames: "装货站点1",
				unlWhids: "16",
				unlWhNames: "卸货站点1",
				avgLoadDuration: 0,
				avgUnlDuration: 0,
				avgTravelDuration: 0,
				avgSumDuration: 0,
				avgFreewayCost: 0,
				avgTollCost: 0,
				avgFuelCost: 0,
				avgSumCost: 0,
				avgFreightMoney: 0,
				avgSumIncome: 0,
				avgSumMoney: 0,
				lineDefSet: null,
				olseRecNo: "",
				olseOrg: "TOP",
				olseDefDuration: "",
				olseDefMilage: "",
				olseDefGas: "",
				olseDefFuel: "",
				olseDefElectricity: "",
				olseDefTollCost: "",
				olseDefFreewayCost: "",
				olseCreator: "",
				olseCretime: "",
				olseModuser: "",
				olseModtime: "",
				
				permissionItem: {
					list: false,
					del: false,
					set: false,
					export: false,
				},

			});

			//重置数据
			const init = async (id) => {
				data.lineId = id;
				data.isDetail = true;
				console.log(id);
				// getDetail(id);
				data.olseDefedit = false;
				data.olseDefeditisReadOnly = true;

				let params = {
					lineId: data.lineId,
				};
				const r = await proxy.$http.get(apiObj.editLine, params);
				if (r) {
					data.orgId = r.data.orgId;
					data.odrType = r.data.odrType;
					data.lineType = r.data.lineType;
					data.odrCount = r.data.odrCount;
					data.whids = r.data.whids;
					data.whNames = r.data.whNames;
					data.loadWhids = r.data.loadWhids;
					data.loadWhNames = r.data.loadWhNames;
					data.unlWhids = r.data.unlWhids;
					data.unlWhNames = r.data.unlWhNames;
					data.avgLoadDuration = r.data.avgLoadDuration;
					data.avgUnlDuration = r.data.avgUnlDuration;
					data.avgTravelDuration = r.data.avgTravelDuration;
					data.avgSumDuration = r.data.avgSumDuration;
					data.avgFreewayCost = r.data.avgFreewayCost;
					data.avgTollCost = r.data.avgTollCost;
					data.avgFuelCost = r.data.avgFuelCost;
					data.avgSumCost = r.data.avgSumCost;
					data.avgFreightMoney = r.data.avgFreightMoney;
					data.avgSumIncome = r.data.avgSumIncome;
					data.avgSumMoney = r.data.avgSumMoney;
					if (r.data.lineDefSet === null || r.data.lineDefSet === undefined || r.data
						.lineDefSet === '') {
						data.lineDefSet = null;
						data.olseDefMilage = '';
						data.olseDefDuration = '';
						data.olseDefGas = '';
						data.olseDefFuel = '';
						data.olseDefElectricity = '';
						data.olseDefTollCost = '';
						data.olseDefFreewayCost = '';
					} else {
						data.lineDefSet = '1';
						data.olseDefMilage = r.data.lineDefSet.olseDefMilage;
						data.olseDefDuration = r.data.lineDefSet.olseDefDuration;
						data.olseDefGas = r.data.lineDefSet.olseDefGas;
						data.olseDefFuel = r.data.lineDefSet.olseDefFuel;
						data.olseDefElectricity = r.data.lineDefSet.olseDefElectricity;
						data.olseDefTollCost = r.data.lineDefSet.olseDefTollCost;
						data.olseDefFreewayCost = r.data.lineDefSet.olseDefFreewayCost;
					}
				}

				getData();
			};

			//获取列表数据
			const getData = async () => {
				let params = {
					page: data.page,
					limit: data.pageSize,
					lineId: data.lineId, //路线编号
				};
				const r = await proxy.$http.get(apiObj.lineOrderList, params);
				console.log(r);
				if (r.respCode == '0000') {
					data.tableData = r.rows;
					data.totalCount = r.total;
				}
			};


			const navClick = (index) => {
				data.index = index;
			};

			const dialogClosedHandle = () => {
				data.isDetail = false;
			};
			const closeModal = () => {
				data.isDetail = false;
			};

			const timeDeltaCount = function(time) {
				if (time) {
					var s = time % 60;
					var m = Math.floor(time / 60) % 60;
					var h = Math.floor(Math.floor(time / 60) / 60);

					if (h !== 0) {
						return h + "小时" + m + "分";
					}
					if (m !== 0) {
						return m + "分";
					}
					return s + "秒";
				} else {
					return ''
				}
			};

			const olseDefeditChange = (value) => {
				data.olseDefedit = value;
				data.olseDefeditisReadOnly = !value;

			};

			//编辑线路标准参数
			const olseDefeditsave = async () => {
				if (!data.permissionItem.set) {
					proxy.$message.error("没有线路标准设置权限！");
					return;
				}

				if (data.olseDefDuration == "" || data.olseDefDuration == null) {
					proxy.$message.error("请填写标准耗时");
					return;
				}
				if (data.olseDefMilage == "" || data.olseDefMilage == null) {
					proxy.$message.error("请填写标准里程");
					return;
				}
				if (data.olseDefGas == "" || data.olseDefGas == null) {
					proxy.$message.error("请填写标准气耗");
					return;
				}
				if (data.olseDefFuel == "" || data.olseDefFuel == null) {
					proxy.$message.error("请填写标准油耗");
					return;
				}
				if (data.olseDefTollCost == "" || data.olseDefTollCost == null) {
					proxy.$message.error("请填写标准路桥费");
					return;
				}
				if (data.olseDefFreewayCost == "" || data.olseDefFreewayCost == null) {
					proxy.$message.error("请填写标准高速费");
					return;
				}

				let params = {
					olseRecNo: data.lineId,
					olseDefDuration: data.olseDefDuration, //标准耗时
					olseDefMilage: data.olseDefMilage, //标准里程
					olseDefGas: data.olseDefGas, //标准气耗
					olseDefFuel: data.olseDefFuel, //标准油耗
					olseDefElectricity: 0, //标准电耗
					olseDefTollCost: data.olseDefTollCost, //标准路桥费
					olseDefFreewayCost: data.olseDefFreewayCost, //标准高速费
				};

				const r = await proxy.$http.post(apiObj.LineSetupdate, params)
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					init(data.lineId);
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}
			};

			return {
				...toRefs(data),
				init,
				closeModal,
				dialogClosedHandle,
				getData,
				navClick,
				timeDeltaCount,
				olseDefeditChange,
				olseDefeditsave
			};
		},
	});
</script>

<style scoped>
	.page_warp {
		width: 100%;
		height: 600px;
	}

	.nav_warp {
		width: 100%;
		height: 60px;
		background: #ffffff;
		border-bottom: 1px solid #eeeeee;
		display: flex;
		align-items: center;
	}

	.nav_item {
		position: relative;
		height: 78px;
		padding: 0 20px;
		margin-left: 50px;
		cursor: pointer;
	}

	.nav_item span {
		font-size: 18px;
		color: #666666;
		line-height: 78px;
	}

	.nav_item_ac span {
		color: #293787 !important;
	}

	.nav_item_line {
		position: absolute;
		width: 90%;
		left: 5%;
		height: 3px;
		background: #293787;
		bottom: 5px;
	}

	.input_row {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
	}

	.input_lable {
		width: 80px;
		text-align: right;
	}

	.input_box {
		width: 50%;
	}

	.input_tree_warp {
		width: calc(100% - 30px);
		height: 300px;
		margin-left: 30px;

		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.manage {
		width: 48%;
		height: 100%;

		display: flex;
	}

	.tree {
		width: calc(100% - 80px);
		height: 100%;
		overflow: auto;
	}

	.footer_btn_warp {
		width: 100%;
		height: 70px;
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cancle_btn {
		width: 116px;
		height: 38px;
		background: #e36a19;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
		margin-right: 90px;
	}

	.confirm_btn {
		width: 116px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
	}

	.platTitle {
		line-height: 100px;
		font-size: 18px;
		color: #000;
		font-weight: 600;
		position: relative;
		padding-left: 20px;
	}

	.platTitle::before {
		content: "";
		width: 4px;
		height: 18px;
		background: #20ca68;
		border-radius: 2px;
		position: absolute;
		top: 42px;
		left: 10px;
	}

	.platItem {
		margin-bottom: 20px;
	}

	.platItemLeft {
		min-width: 100px;
		justify-content: flex-end;
	}

	.platItem input {
		width: 80%;
		height: 38px;
		border: 1px solid #ededed;
		border-radius: 4px;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth {
		width: 80%;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth img {
		width: 190px;
		height: 130px;
	}

	.dialog-footer {
		width: 100%;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.btn {
		padding: 5px 15px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}

	.rpt_tit {
		width: 100%;
		height: 70px;
		text-align: left;
		font-weight: bold;
		line-height: 70px;
		font-size: 18px;
		color: #333333;
		text-indent: 0px;
		padding-bottom: 10px;
	}

	.editimg {
		width: 200px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		margin-right: 10px;
		cursor: pointer;
		color: blue;
	}

	.editimg img {
		width: 14px;
		height: 15px;
		margin-right: 8px;
	}

	.auditwait {
		width: 35px;
		height: 16px;
		background: #0000ff;
		border-radius: 4px;
		text-align: center;
		line-height: 16px;
		font-size: 18px;
		color: #fff;
		padding: 0 5px;
		margin-left: 20px;
	}
</style>